/*
 * Product page extras: Best Seller badge, WELCOME10 promo banner, trust
 * bullets + info grid, and splitting the product description into
 * "Description" / "Measurements" accordions.
 *
 * Implemented as a DOM-insertion script rather than editing
 * sections/main-product.liquid directly: that file is a ~3000-line stock
 * Dawn section (mostly repeated schema/icon-option boilerplate), too large
 * to safely rewrite in one piece. Targeting the stable classes Dawn already
 * renders (.product__title, .product-form__buttons, .product__description)
 * gets the same visual result without touching that file at all.
 */
(function () {
  // 2026-09-20: this file runs a second time whenever a Quick View pop-up
  // opens (quick-add.js re-creates the fetched product's script tags inside
  // the modal). On a product page that second run used to look things up on
  // the whole document, so it found the MAIN product first and re-applied
  // itself there: e.g. every Quick View opened from "You may also like"
  // added another "Order within..." box to the page and left the pop-up
  // without one. When this copy of the script lives inside a Quick View,
  // every lookup below is now limited to that pop-up.
  var ownScript = document.currentScript;
  var quickViewRoot = ownScript && ownScript.closest ? ownScript.closest('quick-add-modal') : null;
  var scope = quickViewRoot || document;
  var scopeById = function (id) {
    if (!quickViewRoot) return document.getElementById(id);
    return quickViewRoot.querySelector('[id="' + String(id).replace(/"/g, '\\"') + '"]');
  };

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  var CHEVRON =
    '<span class="svg-wrapper product__accordion-chevron" aria-hidden="true">' +
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2 5L7 10L12 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  function getVisiblePriceText(container) {
    if (!container) return '';
    var regular = container.querySelector('.price__regular');
    var sale = container.querySelector('.price__sale');
    var visible = null;
    if (sale && window.getComputedStyle(sale).display !== 'none') {
      visible = sale;
    } else if (regular && window.getComputedStyle(regular).display !== 'none') {
      visible = regular;
    }
    if (!visible) return '';
    var item = visible.querySelector('.price-item--sale') || visible.querySelector('.price-item--regular');
    return item ? item.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function buildAccordion(heading) {
    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<div class="product__accordion accordion quick-add-hidden">' +
      '<details>' +
      '<summary>' +
      '<div class="summary__title"><h2 class="h4 accordion__title inline-richtext">' +
      heading +
      '</h2></div>' +
      CHEVRON +
      '</summary>' +
      '<div class="accordion__content rte"></div>' +
      '</details>' +
      '</div>';
    return wrap.firstElementChild;
  }

  ready(function () {
    var infoContainer = scope.querySelector('.product__info-container');
    if (!infoContainer) return;

    // Page-specific tweaks below (custom titles, Best Seller badge, per-page
    // gallery fixes, reel clips) key off the page address. Inside a Quick
    // View none of them apply, whatever page is behind the pop-up: that is
    // how Quick View has always looked from the homepage/collections, and it
    // stops e.g. a Boxer quick view opened on the Lion Mane page from
    // getting the Lion Mane title and Best Seller badge.
    var productPath = quickViewRoot ? '' : window.location.pathname;

    var BEST_SELLER_HANDLES = [
      'funny-lion-mane-hat-for-cats-and-kittens',
      'teddy-pirate-pet-costume-for-halloween-dress-up',
      'pet-costume-for-dogs-dragon-transformation-outfit',
      'denim-costume-for-pets'
    ];

    var BOXER_PRODUCT_PATH = '/products/dog-clothes-and-boxer-cat-costume-outfit';
    var isBoxerPage = productPath.indexOf(BOXER_PRODUCT_PATH) !== -1;

    var LION_MANE_PRODUCT_PATH = '/products/funny-lion-mane-hat-for-cats-and-kittens';
    var isLionManePage = productPath.indexOf(LION_MANE_PRODUCT_PATH) !== -1;

    // 2026-09-03 follow-up: on the Witch Cloak page only, every photo and
    // the 360° video rendered noticeably smaller than on other product
    // pages ("way too small... make them regular size"). Root cause: this
    // product's own main photo is portrait (435x653), and Dawn's own
    // constrain-to-viewport width math (.product-media-container.
    // constrain-height.media-fit-contain in section-main-product.css)
    // computes the whole gallery box's width from that portrait ratio —
    // every other product's main photo is closer to square/landscape, so
    // that same math happens to land near the column's full width there
    // instead. Since every slide (photos and the video) shares one box,
    // the narrow box shrank all of them, not just the portrait photo.
    // Tags the box with a class so component-product-extras.css can force
    // it back to full width on just this page — see the comment there.
    var WITCH_PAGE_PRODUCT_PATH = '/products/pet-halloween-wizard-cloak-costume-set';
    var isWitchPage = productPath.indexOf(WITCH_PAGE_PRODUCT_PATH) !== -1;
    if (isWitchPage) {
      var productMediaContainerEl = scope.querySelector('.product-media-container');
      if (productMediaContainerEl) productMediaContainerEl.classList.add('product-media-container--full-size');
    }

    // 2026-09-05 follow-up: on the Pirate Costume page only, the mobile
    // photo gallery showed a dark, boxy sliver overlapping the bottom-right
    // corner of the main photo. Root cause: Dawn's own mobile slider
    // (.product__media-list, section-main-product.css) deliberately renders
    // each slide ~1cm wider than its own visible frame so the next photo's
    // edge "peeks" in as a swipe hint — invisible on a white-background
    // photo, but a visible dark wedge here because the 2nd photo (beach
    // scene) has a dark background right where it peeks in. This is
    // present on every product's mobile gallery (confirmed live on the
    // Dragon page too, far more visibly, since its 2nd photo is solid dark
    // navy) — scoped to only this page rather than touching the shared
    // slider behavior site-wide, per explicit request to leave every other
    // (already correct) product page untouched.
    var PIRATE_PAGE_PRODUCT_PATH = '/products/teddy-pirate-pet-costume-for-halloween-dress-up';
    var isPiratePage = productPath.indexOf(PIRATE_PAGE_PRODUCT_PATH) !== -1;
    if (isPiratePage) {
      var pirateMediaListEl = scope.querySelector('.product__media-list');
      if (pirateMediaListEl) pirateMediaListEl.classList.add('product__media-list--no-peek');
    }

    // 1. Best Seller badge, inserted right before the product title.
    var titleBlock = infoContainer.querySelector('.product__title');
    if (titleBlock) {
      var path = productPath;
      var isBestSeller = BEST_SELLER_HANDLES.some(function (handle) {
        return path.indexOf('/products/' + handle) !== -1;
      });
      if (isBestSeller) {
        var badgeRow = document.createElement('div');
        badgeRow.className = 'product__badges-row';
        badgeRow.innerHTML =
          '<span class="product__badge-pill product__badge-pill--bestseller">Best Seller</span>';
        titleBlock.parentNode.insertBefore(badgeRow, titleBlock);
      }
    }

    if (isBoxerPage && titleBlock) {
      var boxerTitleH1 = titleBlock.querySelector('h1');
      var boxerTitleH2 = titleBlock.querySelector('h2.h1');
      if (boxerTitleH1) boxerTitleH1.textContent = 'BOXER COSTUME | Dogs';
      if (boxerTitleH2) boxerTitleH2.textContent = 'BOXER COSTUME | Dogs';
      titleBlock.classList.add('product__title--boxer');
    }

    if (isLionManePage && titleBlock) {
      var lionManeTitleH1 = titleBlock.querySelector('h1');
      var lionManeTitleH2 = titleBlock.querySelector('h2.h1');
      if (lionManeTitleH1) lionManeTitleH1.textContent = 'Lion Mane Costume | Cats';
      if (lionManeTitleH2) lionManeTitleH2.textContent = 'Lion Mane Costume | Cats';
    }

    var buttonsWrap = infoContainer.querySelector('.product-form__buttons');

    var variantLabel = infoContainer.querySelector('.product-form__input--pill .form__label');
    if (variantLabel && variantLabel.childNodes.length && variantLabel.querySelector('.product__variant-label-name') === null) {
      var labelTextNode = variantLabel.childNodes[0];
      if (labelTextNode.nodeType === 3) {
        var labelText = labelTextNode.textContent;
        var dashIndex = labelText.indexOf(' - ');
        if (dashIndex !== -1) {
          var labelPrefix = labelText.slice(0, dashIndex);
          var labelSuffix = labelText.slice(dashIndex + 1).trim();
          labelTextNode.textContent = labelPrefix + ' ';
          var labelNameSpan = document.createElement('span');
          labelNameSpan.className = 'product__variant-label-name';
          labelNameSpan.textContent = labelSuffix;
          variantLabel.appendChild(labelNameSpan);
        }
      }
    }

    var descBlock = infoContainer.querySelector('.product__description');
    if (descBlock) {
      var html = descBlock.innerHTML;
      var marker = '📏';
      var idx = html.indexOf(marker);
      var descriptionHtml = idx === -1 ? html : html.slice(0, idx);
      var measurementsHtml = idx === -1 ? '' : '<p><strong>' + marker + html.slice(idx + marker.length);

      var descAccordion = buildAccordion('Description');
      // Only the top tab is "first"; moved to Measurements below when present.
      descAccordion.classList.add('product__accordion--first');
      descAccordion.querySelector('.accordion__content').innerHTML = descriptionHtml;
      descBlock.parentNode.insertBefore(descAccordion, descBlock);
      // 2026-09-20: the Description and Measurements tabs also show inside the
      // Quick View pop-up, per request (buildAccordion marks every accordion
      // quick-add-hidden; the FAQ ones stay hidden there).
      if (quickViewRoot) descAccordion.classList.remove('quick-add-hidden');

      if (measurementsHtml) {
        var measAccordion = buildAccordion('Measurements');
        var measContent = measAccordion.querySelector('.accordion__content');
        measContent.innerHTML = measurementsHtml;
        // 2026-09-22: Measurements now sits ABOVE Description, per request
        // (it was below). It therefore takes the "first accordion" styling
        // (no top border, 0.3cm gap to the divider above).
        descBlock.parentNode.insertBefore(measAccordion, descAccordion);
        descAccordion.classList.remove('product__accordion--first');
        measAccordion.classList.add('product__accordion--first');
        // 2026-09-22: Measurements starts OPEN so shoppers see the sizes
        // without clicking (the customer can still fold it shut).
        measAccordion.querySelector('details').open = true;
        if (quickViewRoot) measAccordion.classList.remove('quick-add-hidden');

        // "As Seen On You" reel videos: one or more Instagram-reel clips
        // shown as small tap-to-enlarge thumbnails, keyed by product path.
        // Only the products below have real clips so far.
        var VAMPIRE_CAPE_PRODUCT_PATH =
          '/products/rosaui-cat-costume-small-breeds-dog-costume-red-black-pet-cape-costume-40cm-back-length-17-40cm-neck-girth-cool-neck-armor-adjustable-strap-velcro-closure';
        var CHINESE_LION_DANCE_PRODUCT_PATH = '/products/jizai-little-lion-costume-for-pets';
        var DRAGON_PRODUCT_PATH = '/products/pet-costume-for-dogs-dragon-transformation-outfit';
        var KILLER_DOLL_PRODUCT_PATH = '/products/halloween-costume-for-dogs-fun-pet-outfit-set';
        var COWBOY_DENIM_PRODUCT_PATH = '/products/denim-costume-for-pets';
        var PIRATE_PRODUCT_PATH = '/products/teddy-pirate-pet-costume-for-halloween-dress-up';
        var REEL_VIDEOS_BY_PATH = {};
        REEL_VIDEOS_BY_PATH[BOXER_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/boxer-costume-reel-poster.jpg?v=1788545503',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/boxer-costume-reel.mp4?v=1788545504'
          }
        ];
        REEL_VIDEOS_BY_PATH[VAMPIRE_CAPE_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/vampire-cloak2-poster.jpg?v=1788552740',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/vampire-cloak2.mp4?v=1788552742'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/vampire-cloak1-poster.jpg?v=1788552741',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/vampire-cloak1.mp4?v=1788552742'
          }
        ];
        REEL_VIDEOS_BY_PATH[CHINESE_LION_DANCE_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/chinese-lion-dance-poster.jpg?v=1788554616',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/chinese-lion-dance.mp4?v=1788554618'
          }
        ];
        REEL_VIDEOS_BY_PATH[DRAGON_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon1-poster.jpg?v=1788555436',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon1.mp4?v=1788555438'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon2-poster.jpg?v=1788555437',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon2.mp4?v=1788555438'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon3-poster.jpg?v=1788555436',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon3.mp4?v=1788555438'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon4-poster.jpg?v=1788555436',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/black-dragon4.mp4?v=1788555438'
          }
        ];
        REEL_VIDEOS_BY_PATH[KILLER_DOLL_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog7-poster.jpg?v=1788556323',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog7.mp4?v=1788556325'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog6-poster.jpg?v=1788556323',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog6.mp4?v=1788556325'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog5-poster.jpg?v=1788556324',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog5.mp4?v=1788556325'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog4-poster.jpg?v=1788556323',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog4.mp4?v=1788556324'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog1-poster.jpg?v=1788556323',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/killer-dog1.mp4?v=1788556325'
          }
        ];
        REEL_VIDEOS_BY_PATH[LION_MANE_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-black3-poster.jpg?v=1788557364',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-black3.mp4?v=1788557365'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-brown4-poster.jpg?v=1788892677',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-brown4_d72a95fa-c705-4379-a29e-b04d932e89f2.mp4?v=1788892730'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-brown3-poster.jpg?v=1788557364',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-brown3.mp4?v=1788557365'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-brown2-poster.jpg?v=1788557364',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-brown2.mp4?v=1788557365'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-black2-poster.jpg?v=1788557364',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/lion-mane-black2.mp4?v=1788557365'
          }
        ];
        REEL_VIDEOS_BY_PATH[COWBOY_DENIM_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/cowboy-denim1-poster.jpg?v=1788562399',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/cowboy-denim1.mp4?v=1788562401'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/cowboy-denim2-poster.jpg?v=1788562908',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/cowboy-denim2.mp4?v=1788562909'
          }
        ];
        REEL_VIDEOS_BY_PATH[PIRATE_PRODUCT_PATH] = [
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate1-poster.jpg?v=1788564068',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate1.mp4?v=1788564069'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate3-poster.jpg?v=1788564067',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate3.mp4?v=1788564069'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate5-poster.jpg?v=1788564067',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate5.mp4?v=1788564069'
          },
          {
            poster: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate4-poster.jpg?v=1788564067',
            video: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate4.mp4?v=1788564069'
          }
        ];

        var reelVideos = REEL_VIDEOS_BY_PATH[productPath];

        // 2026-09-05 follow-up: "As Seen On You" (title + row) is now only
        // built at all when this product actually has real reel clips
        // above — previously the bare title always rendered even with
        // nothing under it on every other product, per explicit request
        // ("Remove the as seen on you title for products that don't
        // already have videos on them").
        if (reelVideos && reelVideos.length) {
          var asSeenSection = document.createElement('div');
          asSeenSection.className = 'product__as-seen-on-you';
          asSeenSection.innerHTML = '<h3 class="product__measurements-title">As Seen On You</h3>';
          descBlock.parentNode.insertBefore(asSeenSection, descBlock);

          var reelRow = document.createElement('div');
          // 2026-09-04 follow-up: when a product has more than 3 clips, the
          // row scrolls horizontally instead of wrapping — the first 3
          // thumbnails sit side by side and the rest are reached by swiping
          // (a tap/swipe arrow on the 3rd thumbnail hints at this, added below).
          reelRow.className = 'product__reel-thumb-row' + (reelVideos.length > 3 ? ' product__reel-thumb-row--scrollable' : '');
          asSeenSection.appendChild(reelRow);

          var productNameForAria = titleBlock ? titleBlock.textContent.trim().split('\n')[0].trim() : 'product';

          reelVideos.forEach(function (reelData, reelIndex) {
            var reelThumb = document.createElement('div');
            reelThumb.className = 'product__reel-thumb';
            reelThumb.setAttribute('role', 'button');
            reelThumb.setAttribute('tabindex', '0');
            reelThumb.setAttribute(
              'aria-label',
              reelVideos.length > 1
                ? 'Play ' + productNameForAria + ' video ' + (reelIndex + 1)
                : 'Play ' + productNameForAria + ' video'
            );
            reelThumb.innerHTML =
              '<video class="product__reel-thumb-video" muted loop playsinline preload="metadata" poster="' + reelData.poster + '">' +
              '<source src="' + reelData.video + '" type="video/mp4">' +
              '</video>' +
              '<span class="product__reel-thumb-play" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>' +
              '</span>';

            reelRow.appendChild(reelThumb);

            // Swipe hint: on the 3rd thumbnail only, when there are more
            // clips beyond it, show a transparent arrow at its right-middle
            // edge. Tapping it also advances the row by one thumbnail, for
            // users who tap instead of swiping.
            if (reelIndex === 2 && reelVideos.length > 3) {
              var swipeArrow = document.createElement('button');
              swipeArrow.type = 'button';
              swipeArrow.className = 'product__reel-swipe-arrow';
              swipeArrow.setAttribute('aria-label', 'Show more videos');
              swipeArrow.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
              swipeArrow.addEventListener('click', function (event) {
                event.stopPropagation();
                var advanceBy = reelThumb.getBoundingClientRect().width + 0.4 * 37.8;
                reelRow.scrollBy({ left: advanceBy, behavior: 'smooth' });
              });
              reelThumb.appendChild(swipeArrow);
            }

            var reelThumbVideoEl = reelThumb.querySelector('video');
            if (window.IntersectionObserver) {
              var reelObserver = new IntersectionObserver(
                function (entries) {
                  entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                      reelThumbVideoEl.play().catch(function () {});
                    } else {
                      reelThumbVideoEl.pause();
                    }
                  });
                },
                { threshold: 0.5 }
              );
              reelObserver.observe(reelThumbVideoEl);
            }

            var openReelModal = function () {
              var overlay = document.createElement('div');
              overlay.className = 'product__reel-modal-overlay';

              var modal = document.createElement('div');
              modal.className = 'product__reel-modal';
              modal.setAttribute('role', 'dialog');
              modal.setAttribute('aria-modal', 'true');
              modal.setAttribute('aria-label', productNameForAria + ' video');

              var closeBtn = document.createElement('button');
              closeBtn.type = 'button';
              closeBtn.className = 'product__reel-modal-close';
              closeBtn.setAttribute('aria-label', 'Close');
              closeBtn.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

              var bigVideo = document.createElement('video');
              bigVideo.className = 'product__reel-modal-video';
              bigVideo.setAttribute('playsinline', '');
              bigVideo.controls = true;
              bigVideo.loop = true;
              bigVideo.poster = reelData.poster;
              bigVideo.innerHTML = '<source src="' + reelData.video + '" type="video/mp4">';

              modal.appendChild(bigVideo);
              overlay.appendChild(modal);
              overlay.appendChild(closeBtn);
              document.body.appendChild(overlay);

              // 2026-09-08 follow-up: "when the customer clicks on the As
              // Seen On You video, automatically put the volume down to
              // 20%" — this modal's <video> has no muted attribute (unlike
              // the small tap-to-enlarge thumbnail, which is always muted),
              // so it plays at whatever volume the browser defaults new
              // <video> elements to (1.0, full volume) the instant it's
              // created. Setting volume here, before play(), means the
              // very first frame of audio already plays at 20% instead of
              // starting full-blast and only correcting after a flash of
              // loud audio.
              bigVideo.volume = 0.2;
              bigVideo.play().catch(function () {});

              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  overlay.classList.add('is-open');
                });
              });

              var removed = false;
              function removeOverlay() {
                if (removed) return;
                removed = true;
                if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
                document.removeEventListener('keydown', onKeydown);
              }
              function onTransitionEnd(event) {
                if (event.target === modal) removeOverlay();
              }
              function closeReelModal() {
                overlay.classList.remove('is-open');
                bigVideo.pause();
                overlay.addEventListener('transitionend', onTransitionEnd);
                window.setTimeout(removeOverlay, 300);
              }
              function onKeydown(event) {
                if (event.key === 'Escape') closeReelModal();
              }

              overlay.addEventListener('click', function (event) {
                if (event.target === overlay) closeReelModal();
              });
              closeBtn.addEventListener('click', closeReelModal);
              document.addEventListener('keydown', onKeydown);
            };

            reelThumb.addEventListener('click', openReelModal);
            reelThumb.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openReelModal();
              }
            });
          });
        }
      }

      var BRAND_STRIP_NAMES = ['Vogue', 'Elle', 'GQ', "Harper's Bazaar", 'Cosmopolitan', 'Marie Claire'];
      var brandStripItemsHtml = BRAND_STRIP_NAMES.map(function (name) {
        return '<span class="product__brand-strip-item">' + name + '</span>';
      }).join('');

      var brandStrip = document.createElement('div');
      brandStrip.className = 'product__brand-strip';
      brandStrip.innerHTML =
        '<div class="product__brand-strip-track">' + brandStripItemsHtml + brandStripItemsHtml + '</div>';
      descBlock.parentNode.insertBefore(brandStrip, descBlock);

      descBlock.remove();
    }

    var insideQuickView = !!infoContainer.closest('quick-add-modal');
    var buyButtonsForBar = infoContainer.querySelector('.product-form__buttons');
    var mediaImg = scope.querySelector('.product__media-with-video-item img, .product-media-container img, media-gallery img');
    var priceContainer = infoContainer.querySelector('.price');
    if (buyButtonsForBar && titleBlock && !insideQuickView) {
      var realAddToCartBtn = buyButtonsForBar.querySelector('button[type="submit"], .product-form__submit');
      var titleText = titleBlock.textContent.trim().split('\n')[0].trim();

      var bar = document.createElement('div');
      bar.className = 'product-sticky-bar';
      bar.innerHTML =
        '<div class="product-sticky-bar__inner page-width">' +
        (mediaImg ? '<img class="product-sticky-bar__thumb" src="' + mediaImg.src + '" alt="" width="50" height="50">' : '') +
        '<div class="product-sticky-bar__info">' +
        '<div class="product-sticky-bar__title">' + titleText + '</div>' +
        '<div class="product-sticky-bar__price"></div>' +
        '</div>' +
        '<button type="button" class="product-sticky-bar__atc button button--primary">Add to cart</button>' +
        '</div>';
      document.body.appendChild(bar);

      var priceTarget = bar.querySelector('.product-sticky-bar__price');
      var syncPrice = function () {
        if (priceTarget) {
          priceTarget.textContent = getVisiblePriceText(priceContainer);
        }
      };
      syncPrice();
      if (priceContainer && window.MutationObserver) {
        new MutationObserver(syncPrice).observe(priceContainer, { childList: true, subtree: true, characterData: true, attributes: true });
      }

      bar.querySelector('.product-sticky-bar__atc').addEventListener('click', function () {
        if (realAddToCartBtn) realAddToCartBtn.click();
      });

      if (window.IntersectionObserver) {
        var isDesktopBar = function () {
          return window.matchMedia('(min-width: 750px)').matches;
        };

        // 2026-09-10 final shape (v3, per request): the popup lives
        // BELOW the "You may also like" section. It rises up from the
        // bottom of the screen once that section's bottom edge has
        // scrolled past the top of the viewport, and flies down out of
        // the site (keyframed) as soon as the visitor heads back up
        // above that line (40px hysteresis against boundary flicker).
        // The earlier As-Seen-On-You barrier stage is gone — the bar
        // is always hidden up there now anyway. Mobile keeps the
        // buy-box trigger; products without a You-may-also-like
        // section fall back to it on desktop too.
        var ymalSectionForBar = scope.querySelector('.related-products');

        var barObserver = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            if (isDesktopBar() && ymalSectionForBar) return;
            var pastBuyBox = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('product-sticky-bar--visible', pastBuyBox);
          },
          { threshold: 0 }
        );
        barObserver.observe(buyButtonsForBar);

        if (ymalSectionForBar) {
          var barShown = false;
          var applyYmalVisibility = function () {
            if (!isDesktopBar()) return;
            // 2026-09-10 follow-up: boundary is the TOP of the "You may
            // also like" title — and per the second follow-up ("appears
            // 10cm too late"), the trigger line sits 10cm (378px) down
            // from the viewport top rather than at its very edge: the
            // popup rises as the visitor ARRIVES at the section (title
            // ~10cm into view), and flies away on the way back up at
            // the same line.
            var YMAL_TRIGGER_LINE = 643; /* 17cm — 10cm, then +7cm per follow-up */
            var ymalTop = ymalSectionForBar.getBoundingClientRect().top;
            if (!barShown && ymalTop <= YMAL_TRIGGER_LINE) {
              barShown = true;
              bar.classList.remove('product-sticky-bar--flyout');
              bar.classList.add('product-sticky-bar--visible');
              // spring entrance (keyframed); removed on hide so each
              // reappearance replays it
              bar.classList.add('product-sticky-bar--springin');
            } else if (barShown && ymalTop > YMAL_TRIGGER_LINE + 40) {
              barShown = false;
              bar.classList.remove('product-sticky-bar--springin');
              bar.classList.add('product-sticky-bar--flyout');
            }
          };
          window.addEventListener('scroll', applyYmalVisibility, { passive: true });
          window.addEventListener('resize', applyYmalVisibility);
          applyYmalVisibility();
        }
      }
    }

    var relatedProducts = scope.querySelector('.related-products');
    if (relatedProducts) {
      var WITCH_PRODUCT_HANDLE = 'pet-halloween-wizard-cloak-costume-set';

      var RELATED_CARD_BEST_SELLER_HANDLES = BEST_SELLER_HANDLES.filter(function (handle) {
        return handle !== 'funny-lion-mane-hat-for-cats-and-kittens';
      });

      var badgeRelatedCards = function () {
        var wrappers = relatedProducts.querySelectorAll('.card-wrapper');
        wrappers.forEach(function (wrapper) {
          if (wrapper.hasAttribute('data-badge-checked')) return;
          wrapper.setAttribute('data-badge-checked', 'true');
          var link = wrapper.querySelector('a[href*="/products/"]');
          if (!link) return;
          var href = link.getAttribute('href');
          var media = wrapper.querySelector('.media');

          var isBestSeller = RELATED_CARD_BEST_SELLER_HANDLES.some(function (handle) {
            return href.indexOf('/products/' + handle) !== -1;
          });
          if (isBestSeller && media) {
            var badge = document.createElement('span');
            badge.className = 'related-card-badge';
            badge.textContent = 'Best Seller';
            media.appendChild(badge);
          }

          if (isBoxerPage && href.indexOf('/products/' + WITCH_PRODUCT_HANDLE) !== -1 && media) {
            media.classList.add('product__card-photo-small');
          }
        });
      };
      badgeRelatedCards();
      new MutationObserver(badgeRelatedCards).observe(relatedProducts, { childList: true, subtree: true });

      var STORY_ITEMS = [
        {
          image: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/small-store-big-character-9x16-catv2.png?v=1787877911',
          title: 'Small Store, Big Character',
          description:
            "PawClo started with a simple idea. Pet costumes shouldn't be a guessing game. We're a small UK store that cares about the details others skip, real measurements, honest descriptions, and costumes built to last. Big personality, small operation.",
          itemClass: 'product__story-item--featured',
          photoClass: 'product__story-photo--transparent-border'
        },
        {
          image: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/horror-dog1-zoomout3.png?v=1786930042',
          title: 'For All Occasions',
          description:
            "Birthdays, holidays, or just a random Tuesday, your pet deserves to look the part. PawClo costumes fit real life, with genuine sizing that gets it right every time.",
          photoClass: 'product__story-photo--transparent-border'
        },
        {
          image: 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/based-in-england-dragon-listing.jpg?v=1787878475',
          title: 'Based In England, Worn Worldwide.',
          description:
            "Designed in the UK, PawClo makes bold pet costumes with real, verified sizing, fitted right the first time. Wherever you are, we bring a little British charm to your pet's wardrobe.",
          photoClass: 'product__story-photo--transparent-border'
        }
      ];

      var storyGrid = document.createElement('div');
      storyGrid.className = 'product__story-grid';
      storyGrid.innerHTML = STORY_ITEMS.map(function (item) {
        return (
          '<div class="product__story-item' + (item.itemClass ? ' ' + item.itemClass : '') + '">' +
          '<div class="product__story-photo' + (item.photoClass ? ' ' + item.photoClass : '') + '"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>' +
          '<h3 class="product__story-title">' + item.title + '</h3>' +
          '<p class="product__story-description">' + item.description + '</p>' +
          '</div>'
        );
      }).join('');

      var relatedProductsWrapper = relatedProducts.parentNode;
      relatedProductsWrapper.parentNode.insertBefore(storyGrid, relatedProductsWrapper.nextSibling);

      var videoStrip = document.createElement('div');
      videoStrip.className = 'product__video-strip';

      var videoStripHeadline = document.createElement('div');
      videoStripHeadline.className = 'product__video-strip-headline';
      videoStripHeadline.textContent = "Outfits your pets won't take off.";
      videoStrip.appendChild(videoStripHeadline);

      var videoStripVideo = document.createElement('video');
      videoStripVideo.className = 'product__video-strip-video';
      videoStripVideo.muted = true;
      videoStripVideo.loop = true;
      videoStripVideo.playsInline = true;
      videoStripVideo.preload = 'auto';
      videoStripVideo.src = 'https://cdn.shopify.com/videos/c/vp/2b60787a8d7947e28f8342880cde0ead/2b60787a8d7947e28f8342880cde0ead.HD-1080p-7.2Mbps-92916156.mp4';
      videoStrip.appendChild(videoStripVideo);

      relatedProductsWrapper.parentNode.insertBefore(videoStrip, storyGrid.nextSibling);

      if (window.IntersectionObserver) {
        var videoStripObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              videoStripVideo.play().catch(function () {});
              videoStripObserver.unobserve(entry.target);
            });
          },
          { threshold: 0.15 }
        );
        videoStripObserver.observe(videoStrip);
      } else {
        videoStripVideo.play().catch(function () {});
      }

      var FAQ_ITEMS = [
        {
          heading: 'Sizing Guide',
          content:
            "<p>Getting the right fit matters — here's everything you need to measure your pet correctly and choose the best size for each costume.</p><p><strong>How to Measure Your Pet</strong></p><ul><li><strong>Neck circumference</strong> — wrap a soft tape measure around the base of the neck, where a collar would normally sit. Leave a little give, don't pull tight.</li><li><strong>Chest circumference</strong> — measure around the widest part of the chest, just behind the front legs.</li><li><strong>Back length</strong> — measure from the base of the neck to the base of the tail.</li><li><strong>Weight</strong> — weigh your pet on a standard scale for products where weight is listed.</li></ul><p>If your pet falls between two sizes, we always recommend sizing up for a comfortable, non-restrictive fit.</p><p>Specific sizes for each costume can be found in the product description on the product page, just scroll down on the item you're interested in to see the exact size chart for that costume.</p>"
        },
        {
          heading: 'How long does shipping take?',
          content:
            "<p>Orders are processed within 1-2 business days and typically arrive in 9-11 days depending on your location. You'll get a tracking link by email as soon as your order ships.</p>"
        },
        {
          heading: 'Returns & Refunds Policy',
          content:
            "<p>We want you to love what you order. Here's exactly how returns and refunds work at PawClo:</p><p><strong>Covered: Full Refund or Replacement</strong></p><p>If your item arrives damaged, defective, or incorrect, we've got you covered. Simply:</p><ul><li>Contact us at Support@PawClo.co.uk within 30 days of delivery</li><li>Include a clear photo or short video showing the issue</li><li>We'll process a full refund or send a replacement, whichever you prefer</li></ul><p>No need to send the item back; once we've verified the issue, you're free to keep or dispose of it.</p><p><strong>Not Covered: Change of Mind</strong></p><p>Because our products are made to order and shipped directly from our fulfillment partners, we're unable to offer refunds or exchanges for change of mind purchases (e.g., no longer wanting the item, or ordering the wrong size by mistake).</p><p>To help you get it right the first time, we strongly recommend:</p><ul><li>Checking the size guide on each product page carefully before ordering</li><li>Reaching out to us before purchasing if you're unsure; we're happy to help you pick the right size</li></ul><p><strong>Lost or Delayed Orders</strong></p><p>If your order hasn't arrived within the estimated delivery window, contact us and we'll investigate. If it's confirmed lost in transit, we'll issue a full refund or reshipment.</p><p><strong>How to Start a Claim</strong></p><p>Email us at Support@PawClo.co.uk with your order number and a description of the issue. We aim to respond within [X] business hours and resolve most claims within 5 to 10 business days.</p>"
        },
        {
          heading: 'How do I care for the costumes?',
          content:
            '<p>Most PawClo costumes are machine washable on a gentle, cold cycle - check the care label on your item. Air drying is recommended to keep colors and shape looking their best.</p>'
        }
      ];

      var faqSection = document.createElement('div');
      faqSection.className = 'product__faq';

      var faqTitle = document.createElement('h2');
      faqTitle.className = 'product__faq-title';
      faqTitle.textContent = 'Frequently Asked Questions';
      faqSection.appendChild(faqTitle);

      FAQ_ITEMS.forEach(function (item, index) {
        var faqAccordion = buildAccordion(item.heading);
        if (index === 0) faqAccordion.classList.add('product__accordion--first');
        faqAccordion.querySelector('.accordion__content').innerHTML = item.content;
        faqSection.appendChild(faqAccordion);
      });

      relatedProductsWrapper.parentNode.insertBefore(faqSection, videoStrip.nextSibling);

      var WHY_SHOP_ICON_QUALITY =
        '<svg class="product__why-shop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9"/></svg>';
      var WHY_SHOP_ICON_SHIPPING =
        '<svg class="product__why-shop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8l9-5 9 5-9 5-9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>';
      var WHY_SHOP_ICON_RETURN =
        '<svg class="product__why-shop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14l-4-4 4-4"/><path d="M5 10h10a5 5 0 010 10h-2"/></svg>';
      var WHY_SHOP_ICON_UK =
        '<svg class="product__why-shop-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.2v2"/><path d="M10.7 4.2h2.6"/><rect x="8.5" y="5.8" width="7" height="6.2" rx="0.6"/><circle cx="12" cy="8.9" r="2"/><path d="M12 8.9V7.6M12 8.9l1 0.7"/><path d="M9 12v9"/><path d="M15 12v9"/><path d="M9 15.3h6"/><path d="M9 18.4h6"/><path d="M6.5 21h11"/></svg>';

      var WHY_SHOP_ITEMS = [
        {
          title: 'Quality Checked',
          text: 'Every costume is chosen for comfort and durability, not just looks.',
          icon: WHY_SHOP_ICON_QUALITY
        },
        {
          title: 'Same-Day Processing',
          text: 'Orders are processed and shipped the same day, with tracking sent straight to your inbox. Delivery typically takes 9-11 days.',
          icon: WHY_SHOP_ICON_SHIPPING
        },
        {
          title: 'Damage Protection',
          text: "If your item arrives damaged in transit, we'll sort a full refund or replacement, no hassle.",
          icon: WHY_SHOP_ICON_RETURN
        },
        {
          title: 'Designed In England',
          text: 'Family run business since 2026.',
          icon: WHY_SHOP_ICON_UK
        }
      ];

      var whyShopSection = document.createElement('div');
      whyShopSection.className = 'product__why-shop';
      whyShopSection.innerHTML =
        '<div class="product__why-shop-grid">' +
        WHY_SHOP_ITEMS.map(function (item) {
          return (
            '<div class="product__why-shop-item">' +
            item.icon +
            '<h3 class="product__why-shop-item-title">' + item.title + '</h3>' +
            '<p class="product__why-shop-item-text">' + item.text + '</p>' +
            '</div>'
          );
        }).join('') +
        '</div>';

      var whyShopGridEl = whyShopSection.querySelector('.product__why-shop-grid');
      var whyShopDots = document.createElement('div');
      whyShopDots.className = 'product__why-shop-dots';
      whyShopDots.innerHTML = WHY_SHOP_ITEMS.map(function (_, index) {
        return '<span class="product__why-shop-dot' + (index === 0 ? ' is-active' : '') + '"></span>';
      }).join('');
      whyShopSection.appendChild(whyShopDots);

      var whyShopDotEls = whyShopDots.querySelectorAll('.product__why-shop-dot');
      // 2026-09-20: slides are a full strip-width each PLUS a 24px flex gap,
      // so "index * clientWidth" drifts 24px further off per slide (73px by
      // the 4th, "Designed in England"). Use each slide's real position.
      var whyShopSlideLeft = function (index) {
        var slides = whyShopGridEl.children;
        if (!slides.length) return 0;
        var i = Math.max(0, Math.min(index, slides.length - 1));
        return slides[i].offsetLeft - slides[0].offsetLeft;
      };
      var whyShopNearestIndex = function (scrollLeft) {
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < whyShopGridEl.children.length; i++) {
          var d = Math.abs(scrollLeft - whyShopSlideLeft(i));
          if (d < bestDist) { bestDist = d; best = i; }
        }
        return best;
      };
      whyShopGridEl.addEventListener('scroll', function () {
        var activeIndex = whyShopNearestIndex(whyShopGridEl.scrollLeft);
        whyShopDotEls.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      });

      // 2026-09-10 (desktop only): the Why-Shop / "Quality Checked"
      // strip auto-advances every 4 seconds (wrapping back to the first
      // slide) and supports hold-and-drag with the mouse, per request.
      // The timer pauses while the visitor is holding a drag and
      // restarts fresh on release, so it never fights their hand; it
      // also skips ticks while the tab is hidden. During a drag a class
      // disables the grid's `scroll-snap-type: x mandatory` (which
      // would otherwise yank the strip back every frame), and release
      // snaps smoothly to the nearest/intended slide — a ~60px pull is
      // enough to commit to the next one.
      if (window.matchMedia('(min-width: 750px)').matches) {
        var whyShopIndexNow = function () {
          return whyShopNearestIndex(whyShopGridEl.scrollLeft);
        };
        var whyShopGoTo = function (index) {
          whyShopGridEl.scrollTo({ left: whyShopSlideLeft(index), behavior: 'smooth' });
        };
        var whyShopTick = function () {
          if (document.visibilityState !== 'visible') return;
          whyShopGoTo((whyShopIndexNow() + 1) % WHY_SHOP_ITEMS.length);
        };
        var whyShopTimer = setInterval(whyShopTick, 4000);
        var restartWhyShopTimer = function () {
          clearInterval(whyShopTimer);
          whyShopTimer = setInterval(whyShopTick, 4000);
        };

        var whyShopDrag = null;
        whyShopGridEl.style.cursor = 'grab';
        whyShopGridEl.addEventListener('mousedown', function (event) {
          whyShopDrag = { startX: event.clientX, startScroll: whyShopGridEl.scrollLeft };
          whyShopGridEl.classList.add('product__why-shop-grid--dragging');
          whyShopGridEl.style.cursor = 'grabbing';
          clearInterval(whyShopTimer);
          event.preventDefault();
        });
        window.addEventListener('mousemove', function (event) {
          if (!whyShopDrag) return;
          whyShopGridEl.scrollLeft = whyShopDrag.startScroll - (event.clientX - whyShopDrag.startX);
        });
        window.addEventListener('mouseup', function (event) {
          if (!whyShopDrag) return;
          var dx = event.clientX - whyShopDrag.startX;
          var target;
          if (dx < -60) {
            target = whyShopNearestIndex(whyShopDrag.startScroll) + 1;
          } else if (dx > 60) {
            target = whyShopNearestIndex(whyShopDrag.startScroll) - 1;
          } else {
            target = whyShopIndexNow();
          }
          // 2026-09-10: wrap instead of clamping at the ends, per
          // request — dragging onward from the last slide loops back to
          // the first (Quality Checked), mirroring the auto-timer's
          // wrap; the same applies dragging backwards from the first.
          target = ((target % WHY_SHOP_ITEMS.length) + WHY_SHOP_ITEMS.length) % WHY_SHOP_ITEMS.length;
          whyShopGridEl.style.cursor = 'grab';
          whyShopDrag = null;
          whyShopGoTo(target);
          // 2026-09-10 follow-up ("it jolts and snaps"): the
          // --dragging class must stay ON through the settle glide —
          // removing it at the moment of release re-enables
          // `scroll-snap-type: x mandatory`, and the browser instantly
          // re-snaps to the nearest slide edge, visibly yanking the
          // strip before the smooth scroll above can play. The class
          // comes off once the glide finishes (scrollend, with a
          // timeout fallback for browsers without it) — unless a new
          // drag has started in the meantime, which owns the class now.
          var releaseSettle = function () {
            whyShopGridEl.removeEventListener('scrollend', releaseSettle);
            clearTimeout(settleTimer);
            if (whyShopDrag) return;
            whyShopGridEl.classList.remove('product__why-shop-grid--dragging');
          };
          var settleTimer = setTimeout(releaseSettle, 700);
          whyShopGridEl.addEventListener('scrollend', releaseSettle);
          restartWhyShopTimer();
        });
      }

      relatedProductsWrapper.parentNode.insertBefore(whyShopSection, faqSection.nextSibling);

      var instagramTitle = document.createElement('h2');
      instagramTitle.className = 'product__instagram-title';
      instagramTitle.textContent = 'Follow Us on Instagram';
      relatedProductsWrapper.parentNode.insertBefore(instagramTitle, whyShopSection.nextSibling);

      var instagramHandle = document.createElement('a');
      instagramHandle.className = 'product__instagram-handle';
      instagramHandle.href = 'https://www.instagram.com/officialpawclo';
      instagramHandle.target = '_blank';
      instagramHandle.rel = 'noopener';
      instagramHandle.textContent = '@officialpawclo';
      relatedProductsWrapper.parentNode.insertBefore(instagramHandle, instagramTitle.nextSibling);

      // 2026-09-20: "Daily Videos!" sub-title with a video-camera icon to its
      // left, under the title/handle and above the reels grid, per request.
      var instagramSubtitle = document.createElement('p');
      instagramSubtitle.className = 'product__instagram-subtitle';
      instagramSubtitle.innerHTML =
        '<span class="product__instagram-subtitle-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="6" width="13" height="12" rx="2.5"/><path d="M15.5 10.5l5-3v9l-5-3z"/></svg>' +
        '</span>' +
        '<span class="product__instagram-subtitle-text">Daily Videos!</span>';
      // Order (per request): title, "Daily Videos!", then the @handle.
      relatedProductsWrapper.parentNode.insertBefore(instagramSubtitle, instagramHandle);

      var INSTAGRAM_GALLERY_IMAGES = [
        'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/pirate-cat-listing.png?v=1787960194',
        'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/dog-upright-pose.png?v=1787960194',
        'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/horror-dog1-full.png?v=1787960197',
        'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/horror-9x16.png?v=1787960194',
        'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/cat-main-banner-updated_31893c80-91ab-4173-9e3d-0a4baf33b18f.png?v=1787960194',
        'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/witch-listing.png?v=1787960194'
      ];

      // 2026-09-19/20: the grid shows the six most recent Instagram reels.
      // Sources, in order of preference:
      //   1. assets/instagram-reels.json (+ assets/ig-reel-<code>.jpg covers),
      //      pushed daily by the local sync script on Ashley's PC; its URL is
      //      the data-asset-url on #PawcloInstagramReels.
      //   2. the shop.metafields.pawclo.instagram_reels JSON printed inside
      //      that same tag by snippets/product-media-gallery.liquid.
      //   3. the static INSTAGRAM_GALLERY_IMAGES above, so the section never
      //      goes blank.
      // Each reel tile links to the reel on Instagram.
      var reelsNode = scopeById('PawcloInstagramReels');

      // `ver` is the ?v= fingerprint of instagram-reels.json; relative cover
      // filenames get the same tag so the CDN/browser never serve a stale
      // copy after the daily sync overwrites a cover under the same name.
      var normaliseReels = function (list, base, ver) {
        if (!Array.isArray(list)) return [];
        var absolute = function (u) {
          u = String(u);
          if (!/^(https?:)?\/\//.test(u) && base) u = base + u + (ver ? '?v=' + ver : '');
          return u;
        };
        return list.filter(function (r) {
          return r && r.image && r.permalink;
        }).slice(0, 6).map(function (r) {
          // `video` (optional) is a muted mp4 of the reel, also pushed by the sync.
          // `caption` / `timestamp` (optional) feed the on-site reel pop-up.
          return {
            permalink: String(r.permalink),
            image: absolute(r.image),
            video: r.video ? absolute(r.video) : '',
            caption: typeof r.caption === 'string' ? r.caption : '',
            // true only when the synced clip carries a soundtrack.
            audio: r.audio === true,
            timestamp: r.timestamp ? String(r.timestamp) : ''
          };
        });
      };

      // Account details for the pop-up header; the asset JSON overrides these
      // with the real Instagram profile picture once it has loaded.
      var instagramProfile = { username: 'officialpawclo', image: '' };

      var instagramGallery = document.createElement('div');
      instagramGallery.className = 'product__instagram-gallery';

      // 2026-09-20: each tile shows the reel's cover with a play button in
      // the middle. Clicking a tile (anywhere, badge included, at every
      // width) opens an Instagram-style pop-up ON the site instead of
      // sending the customer to Instagram: the reel plays on the left and a
      // white panel on the right shows the profile picture + username, a
      // grey rule, the caption with its "18h"-style age, and the posting
      // date at the very bottom. (Inline click-to-play in the tile, and
      // autoplay-on-scroll before it, were replaced by this, per request.)
      // The tile keeps its Instagram href only as a no-JS fallback.
      var ICON_INSTAGRAM = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r="1" fill="currentColor" stroke="none"/></svg>';
      // Solid white disc with the play triangle cut out (evenodd hole), so the
      // darkened photo shows through the arrow. Sized by CSS (1cm).
      // The cut-out is tinted half-dark: on light footage a fully clear arrow
      // read as a bite out of the disc's right side, so the photo still shows
      // through but the arrow keeps its shape on every background.
      var ICON_PLAY = '<svg viewBox="0 0 24 24"><path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zM9.6 7.2v9.6l8-4.8z"/><path fill="rgba(0,0,0,0.55)" d="M9.6 7.2v9.6l8-4.8z"/></svg>';

      var ICON_POPUP_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M4 4l16 16M20 4L4 20"/></svg>';
      var ICON_POPUP_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 6l-6 6 6 6"/></svg>';
      var ICON_POPUP_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 6l6 6-6 6"/></svg>';

      // Volume button (top left of the reel in the pop-up).
      var ICON_POPUP_SOUND_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M16 9l6 6M22 9l-6 6"/></svg>';
      var ICON_POPUP_SOUND_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H3v6h3l5 4z" fill="currentColor"/><path d="M15.5 9a4.2 4.2 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11"/></svg>';
      // Per request: reels with a soundtrack start playing WITH sound at 25%
      // volume, and a slider ("line") beside the button lets the customer
      // change it. Their mute choice and volume carry over to the other
      // reels they open on this page.
      var popupSoundOn = true;
      var popupVolume = 0.25;

      var escapeReelHtml = function (text) {
        return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      };

      // Caption as Instagram shows it: hashtags/mentions in Instagram's link
      // blue (plain text here, nothing leads off the site) and any
      // pawclo.co.uk address turned into a real link, since that keeps the
      // customer on the store.
      var formatReelCaption = function (caption) {
        return escapeReelHtml(caption)
          .replace(/(^|\s)((?:https?:\/\/)?(?:www\.)?pawclo\.co\.uk[^\s<]*)/gi, function (match, lead, url) {
            var href = /^https?:\/\//i.test(url) ? url : 'https://' + url;
            return lead + '<a class="product__instagram-popup-link" href="' + href + '">' + url + '</a>';
          })
          .replace(/(^|\s)([#@][A-Za-z0-9_.]+)/g, '$1<span class="product__instagram-popup-tag">$2</span>');
      };

      // Instagram's short age format: 5s, 12m, 18h, 3d, 2w.
      var formatReelAge = function (date) {
        var seconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
        if (seconds < 60) return seconds + 's';
        if (seconds < 3600) return Math.floor(seconds / 60) + 'm';
        if (seconds < 86400) return Math.floor(seconds / 3600) + 'h';
        if (seconds < 604800) return Math.floor(seconds / 86400) + 'd';
        return Math.floor(seconds / 604800) + 'w';
      };

      var parseReelDate = function (timestamp) {
        // The API sends "+0000", which Safari only parses as "+00:00".
        var date = new Date(String(timestamp).replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
        return isNaN(date.getTime()) ? null : date;
      };

      var openInstagramPopup = function (reels, startIndex, opener) {
        var index = startIndex;
        var overlay = document.createElement('div');
        overlay.className = 'product__instagram-popup-overlay';
        overlay.innerHTML =
          '<button type="button" class="product__instagram-popup-close" aria-label="Close">' + ICON_POPUP_CLOSE + '</button>' +
          '<button type="button" class="product__instagram-popup-nav product__instagram-popup-nav--prev" aria-label="Previous reel">' + ICON_POPUP_PREV + '</button>' +
          '<button type="button" class="product__instagram-popup-nav product__instagram-popup-nav--next" aria-label="Next reel">' + ICON_POPUP_NEXT + '</button>' +
          '<div class="product__instagram-popup" role="dialog" aria-modal="true" aria-label="PawClo Instagram reel"></div>';
        var popup = overlay.querySelector('.product__instagram-popup');
        var closeBtn = overlay.querySelector('.product__instagram-popup-close');
        var prevBtn = overlay.querySelector('.product__instagram-popup-nav--prev');
        var nextBtn = overlay.querySelector('.product__instagram-popup-nav--next');
        var currentVideo = null;

        // Phones get a compact full-screen layout (close button in the header).
        var isPhone = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
        // 2026-09-22: at every width, the profile picture and the username are
        // links to the PawClo Instagram profile (new tab), per request.
        // (2026-09-20 had this on phones only; desktop stayed plain.)
        var profileUrl = 'https://www.instagram.com/' + encodeURIComponent(instagramProfile.username) + '/';
        var profileEl = function (className, inner, label) {
          return '<a class="' + className + ' product__instagram-popup-profile-link" href="' + profileUrl + '" target="_blank" rel="noopener"' +
            (label ? ' aria-label="' + label + '"' : '') + '>' + inner + '</a>';
        };
        var avatarHtml = function () {
          return profileEl(
            'product__instagram-popup-avatar',
            instagramProfile.image ? '<img src="' + escapeReelHtml(instagramProfile.image) + '" alt="" loading="lazy">' : '',
            'PawClo on Instagram'
          );
        };

        var showReel = function () {
          var reel = reels[index];
          var date = reel.timestamp ? parseReelDate(reel.timestamp) : null;
          var username = escapeReelHtml(instagramProfile.username);
          if (currentVideo) currentVideo.pause();

          popup.innerHTML =
            '<div class="product__instagram-popup-media">' +
              (reel.video
                ? '<video class="product__instagram-popup-video" muted loop playsinline autoplay poster="' + escapeReelHtml(reel.image) + '" src="' + escapeReelHtml(reel.video) + '"></video>' +
                  '<span class="product__instagram-popup-play" aria-hidden="true">' + ICON_PLAY + '</span>' +
                  '<button type="button" class="product__instagram-popup-sound" aria-label="Turn sound on">' + ICON_POPUP_SOUND_OFF + '</button>' +
                  (reel.audio ? '<input type="range" class="product__instagram-popup-volume" min="0" max="100" step="1" aria-label="Volume">' : '') +
                  '<span class="product__instagram-popup-sound-note" role="status" hidden>This video has no sound</span>'
                : '<img class="product__instagram-popup-video" src="' + escapeReelHtml(reel.image) + '" alt="PawClo Instagram reel">') +
            '</div>' +
            '<div class="product__instagram-popup-panel">' +
              '<div class="product__instagram-popup-header">' + avatarHtml() +
                profileEl('product__instagram-popup-username', username) +
              '</div>' +
              '<div class="product__instagram-popup-body">' + avatarHtml() +
                '<div class="product__instagram-popup-caption-wrap">' +
                  '<p class="product__instagram-popup-caption">' + profileEl('product__instagram-popup-username', username) + ' ' + formatReelCaption(reel.caption) + '</p>' +
                  (date ? '<time class="product__instagram-popup-age" datetime="' + date.toISOString() + '">' + formatReelAge(date) + '</time>' : '') +
                '</div>' +
              '</div>' +
              '<div class="product__instagram-popup-footer">' +
                (date ? '<time class="product__instagram-popup-date" datetime="' + date.toISOString() + '">' + date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) + '</time>' : '') +
              '</div>' +
            '</div>';

          // Phones: the pop-up fills the screen, so the close button sits in the
          // header (dark, right-hand end) instead of floating over the backdrop.
          if (isPhone) popup.querySelector('.product__instagram-popup-header').appendChild(closeBtn);

          // Heading off to Instagram: stop the reel (and its sound) here.
          Array.prototype.forEach.call(popup.querySelectorAll('.product__instagram-popup-profile-link'), function (link) {
            link.addEventListener('click', function () {
              if (currentVideo) currentVideo.pause();
            });
          });

          prevBtn.hidden = index === 0;
          nextBtn.hidden = index === reels.length - 1;

          currentVideo = popup.querySelector('video');
          if (currentVideo) {
            var media = popup.querySelector('.product__instagram-popup-media');
            var video = currentVideo;
            var soundBtn = popup.querySelector('.product__instagram-popup-sound');
            var soundNote = popup.querySelector('.product__instagram-popup-sound-note');
            var soundNoteTimer = null;
            var volumeSlider = popup.querySelector('.product__instagram-popup-volume');
            var applySound = function () {
              var on = !!(reel.audio && popupSoundOn && popupVolume > 0);
              video.muted = !on;
              video.volume = popupVolume;
              soundBtn.innerHTML = on ? ICON_POPUP_SOUND_ON : ICON_POPUP_SOUND_OFF;
              soundBtn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
              if (volumeSlider) {
                var shown = on ? Math.round(popupVolume * 100) : 0;
                volumeSlider.value = shown;
                // Drives the filled part of the line in CSS.
                volumeSlider.style.setProperty('--volume', shown + '%');
              }
            };
            applySound();
            if (volumeSlider) {
              volumeSlider.addEventListener('input', function () {
                popupVolume = Math.max(0, Math.min(1, Number(volumeSlider.value) / 100));
                popupSoundOn = popupVolume > 0;
                applySound();
              });
              // Dragging the line is not a pause/resume click on the reel.
              volumeSlider.addEventListener('click', function (event) { event.stopPropagation(); });
            }
            soundBtn.addEventListener('click', function (event) {
              // Not a pause/resume click on the reel underneath.
              event.stopPropagation();
              if (!reel.audio) {
                // Silent clip: say so, the way Instagram does.
                soundNote.hidden = false;
                window.clearTimeout(soundNoteTimer);
                soundNoteTimer = window.setTimeout(function () { soundNote.hidden = true; }, 2200);
                return;
              }
              popupSoundOn = !popupSoundOn;
              // Un-muting from zero would be silent; go back to the 25% default.
              if (popupSoundOn && popupVolume === 0) popupVolume = 0.25;
              applySound();
            });
            video.addEventListener('pause', function () { media.classList.add('is-paused'); });
            video.addEventListener('playing', function () { media.classList.remove('is-paused'); });
            // Like Instagram: click the reel to pause / resume.
            media.addEventListener('click', function () {
              if (video.paused) {
                var resumed = video.play();
                if (resumed && resumed.catch) resumed.catch(function () {});
              } else {
                video.pause();
              }
            });
            var started = video.play();
            if (started && started.catch) {
              started.catch(function () {
                // Browser refused playback with sound: start muted instead.
                if (video.muted) return;
                popupSoundOn = false;
                applySound();
                var retried = video.play();
                if (retried && retried.catch) retried.catch(function () {});
              });
            }
          }
        };

        // The pop-up is centred and its width comes from the 9:16 ratio, so it
        // usually lands on a fraction of a pixel, which made the small volume
        // icon (and the text) render soft. Nudge it onto whole pixels.
        var snapPopup = function () {
          popup.style.left = '0px';
          popup.style.top = '0px';
          var rect = popup.getBoundingClientRect();
          popup.style.left = (Math.round(rect.left) - rect.left) + 'px';
          popup.style.top = (Math.round(rect.top) - rect.top) + 'px';
        };

        var removed = false;
        var removeOverlay = function () {
          if (removed) return;
          removed = true;
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        };
        var closePopup = function () {
          if (currentVideo) currentVideo.pause();
          document.removeEventListener('keydown', onKeydown);
          window.removeEventListener('resize', snapPopup);
          document.body.classList.remove('overflow-hidden');
          overlay.classList.remove('is-open');
          window.setTimeout(removeOverlay, 250);
          if (opener && opener.focus) opener.focus({ preventScroll: true });
        };
        var step = function (delta) {
          var next = index + delta;
          if (next < 0 || next >= reels.length) return;
          index = next;
          showReel();
        };
        function onKeydown(event) {
          if (event.key === 'Escape') closePopup();
          // On the volume line the arrow keys change the volume instead.
          else if (event.target && event.target.type === 'range') return;
          else if (event.key === 'ArrowLeft') step(-1);
          else if (event.key === 'ArrowRight') step(1);
        }

        overlay.addEventListener('click', function (event) {
          if (event.target === overlay) closePopup();
        });
        closeBtn.addEventListener('click', closePopup);
        prevBtn.addEventListener('click', function () { step(-1); });
        nextBtn.addEventListener('click', function () { step(1); });
        document.addEventListener('keydown', onKeydown);

        document.body.appendChild(overlay);
        document.body.classList.add('overflow-hidden');
        showReel();
        // Measure once the open animation (a scale) has finished; while it is
        // scaled the box's rect is not its resting position.
        popup.addEventListener('transitionend', snapPopup);
        window.setTimeout(snapPopup, 300);
        window.addEventListener('resize', snapPopup);
        closeBtn.focus({ preventScroll: true });
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            overlay.classList.add('is-open');
          });
        });
      };

      var renderInstagramReels = function (reels) {
        if (reels.length) {
          instagramGallery.classList.add('product__instagram-gallery--reels');
          instagramGallery.innerHTML = reels.map(function (reel) {
            var safeImg = reel.image.replace(/"/g, '&quot;');
            var safeLink = reel.permalink.replace(/"/g, '&quot;');
            // data-reel = the reel shortcode, so CSS can tweak one specific cover.
            var reelCode = ((reel.permalink.match(/\/reel\/([^/?#]+)/) || [])[1] || '').replace(/[^A-Za-z0-9_-]/g, '');
            var hasVideo = !!reel.video;
            return '<a class="product__instagram-gallery-reel' + (hasVideo ? ' product__instagram-gallery-reel--has-video' : '') + '" data-reel="' + reelCode + '" href="' + safeLink + '" target="_blank" rel="noopener" aria-label="Play this reel">' +
              '<img class="product__instagram-gallery-photo" src="' + safeImg + '" alt="PawClo Instagram reel" loading="lazy">' +
              '<span class="product__instagram-gallery-play" aria-hidden="true">' + ICON_PLAY + '</span>' +
              '<span class="product__instagram-gallery-reel-badge" aria-hidden="true">' + ICON_INSTAGRAM + '</span>' +
            '</a>';
          }).join('');

          // Every tile opens the on-site pop-up instead of leaving for Instagram.
          var reelTiles = instagramGallery.querySelectorAll('.product__instagram-gallery-reel');
          Array.prototype.forEach.call(reelTiles, function (tile, tileIndex) {
            tile.addEventListener('click', function (event) {
              event.preventDefault();
              openInstagramPopup(reels, tileIndex, tile);
            });
          });
        } else {
          instagramGallery.classList.remove('product__instagram-gallery--reels');
          instagramGallery.innerHTML = INSTAGRAM_GALLERY_IMAGES.map(function (src) {
            return '<img class="product__instagram-gallery-photo" src="' + src + '" alt="PawClo Instagram photo" loading="lazy">';
          }).join('');
        }
      };

      var metafieldReels = [];
      try {
        var reelsData = reelsNode ? JSON.parse(reelsNode.textContent || '{}') : null;
        metafieldReels = normaliseReels(reelsData && reelsData.reels, '');
      } catch (e) {
        metafieldReels = [];
      }

      var assetUrl = reelsNode ? reelsNode.getAttribute('data-asset-url') : '';
      if (assetUrl && window.fetch) {
        fetch(assetUrl, { cache: 'no-cache' }).then(function (res) {
          if (!res.ok) throw new Error('no reels asset');
          return res.json();
        }).then(function (data) {
          var base = assetUrl.replace(/instagram-reels\.json.*$/, '');
          var ver = (assetUrl.match(/[?&]v=(\d+)/) || [])[1] || '';
          var assetReels = normaliseReels(data && data.reels, base, ver);
          if (data && data.username) instagramProfile.username = String(data.username);
          if (data && data.profile_image) instagramProfile.image = base + data.profile_image + (ver ? '?v=' + ver : '');
          renderInstagramReels(assetReels.length ? assetReels : metafieldReels);
        }).catch(function () {
          renderInstagramReels(metafieldReels);
        });
      } else {
        renderInstagramReels(metafieldReels);
      }
      relatedProductsWrapper.parentNode.insertBefore(instagramGallery, instagramHandle.nextSibling);
    }

    var videoPanel = scope.querySelector('[data-video-panel]');
    if (videoPanel) {
      var video = videoPanel.querySelector('video');
      var pauseIcon = videoPanel.querySelector('[data-pause-icon]');
      var playIcon = videoPanel.querySelector('[data-play-icon]');
      videoPanel.addEventListener('click', function () {
        if (!video) return;
        if (video.paused) {
          video.play();
          videoPanel.classList.remove('product__video-panel--paused');
          if (pauseIcon) pauseIcon.style.display = '';
          if (playIcon) playIcon.style.display = 'none';
        } else {
          video.pause();
          videoPanel.classList.add('product__video-panel--paused');
          if (pauseIcon) pauseIcon.style.display = 'none';
          if (playIcon) playIcon.style.display = '';
        }
      });
    }

    var liquidData = scopeById('product-extras-liquid-data');
    if (liquidData) {
      var ratingEl = liquidData.querySelector('.product__rating-summary');
      var timerEl = liquidData.querySelector('.product__dispatch-timer');
      var availabilityEl = liquidData.querySelector('.product__availability-row');
      var paymentEl = liquidData.querySelector('.product__payment-icons');

      if (ratingEl && titleBlock) {
        titleBlock.parentNode.insertBefore(ratingEl, titleBlock);
      }

      if (timerEl) {
        var variantSelects = infoContainer.querySelector('variant-selects');
        if (variantSelects && variantSelects.parentNode) {
          variantSelects.parentNode.insertBefore(timerEl, variantSelects.nextSibling);
        } else if (buttonsWrap) {
          buttonsWrap.parentNode.insertBefore(timerEl, buttonsWrap);
        }
      }

      if (buttonsWrap) {
        var formElForExtras = buttonsWrap.closest('product-form') || buttonsWrap.parentNode;
        var afterFormForExtras = formElForExtras.nextSibling;

        // 2026-09-09: measurements reminder — originally under the size
        // picker, moved per follow-up to sit directly UNDER the black
        // Add to Cart button (inserted first here, so it lands above
        // the availability/payment rows that follow). Desktop-only per
        // the day's standing rule — display:none below 750px (CSS in
        // product-media-gallery.liquid) leaves mobile untouched.
        var sizeNote = document.createElement('p');
        sizeNote.className = 'product__size-measure-note';
        sizeNote.innerHTML =
          '<span class="product__size-measure-note-mark" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.2v5.6"/><path d="M12 16.4h.01"/></svg>' +
          '</span>' +
          'Please check the measurements section below for the specific product before you purchase.';
        formElForExtras.parentNode.insertBefore(sizeNote, afterFormForExtras);

        if (availabilityEl) {
          formElForExtras.parentNode.insertBefore(availabilityEl, afterFormForExtras);
        }
        if (paymentEl) {
          formElForExtras.parentNode.insertBefore(paymentEl, afterFormForExtras);
        }

        var divider = document.createElement('hr');
        divider.className = 'product__divider';
        formElForExtras.parentNode.insertBefore(divider, afterFormForExtras);

        var TRUST_BADGE_ICON_UK =
          '<svg class="product__trust-badges-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.2v2"/><path d="M10.7 4.2h2.6"/><rect x="8.5" y="5.8" width="7" height="6.2" rx="0.6"/><circle cx="12" cy="8.9" r="2"/><path d="M12 8.9V7.6M12 8.9l1 0.7"/><path d="M9 12v9"/><path d="M15 12v9"/><path d="M9 15.3h6"/><path d="M9 18.4h6"/><path d="M6.5 21h11"/></svg>';
        var TRUST_BADGE_ICON_SHIPPING =
          '<svg class="product__trust-badges-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8l9-5 9 5-9 5-9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>';
        var TRUST_BADGE_ICON_SECURE =
          '<svg class="product__trust-badges-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
        var TRUST_BADGE_ICON_SUPPORT =
          '<svg class="product__trust-badges-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><path d="M5.5 5.5l3 3M18.5 5.5l-3 3M5.5 18.5l3-3M18.5 18.5l-3-3"/></svg>';

        var trustBadgesGrid = document.createElement('div');
        trustBadgesGrid.className = 'product__trust-badges-grid';
        trustBadgesGrid.innerHTML =
          '<div class="product__trust-badges-grid-item">' + TRUST_BADGE_ICON_UK + '<div class="product__trust-badges-grid-item-text"><strong>England, UK Based</strong><span>Designed in the United Kingdom, worn worldwide</span></div></div>' +
          '<div class="product__trust-badges-grid-item">' + TRUST_BADGE_ICON_SHIPPING + '<div class="product__trust-badges-grid-item-text"><strong>Free UK Shipping</strong><span>Free shipping on UK orders over £50</span></div></div>' +
          '<div class="product__trust-badges-grid-item">' + TRUST_BADGE_ICON_SECURE + '<div class="product__trust-badges-grid-item-text"><strong>Tracked and Secure Shipping</strong><span>Tracking with order included</span></div></div>' +
          '<div class="product__trust-badges-grid-item">' + TRUST_BADGE_ICON_SUPPORT + '<div class="product__trust-badges-grid-item-text"><strong>30-Day Issue Support</strong><span>Dedicated Support<br>Team</span></div></div>';
        formElForExtras.parentNode.insertBefore(trustBadgesGrid, afterFormForExtras);

        var divider2 = document.createElement('hr');
        divider2.className = 'product__divider product__divider--bottom';
        formElForExtras.parentNode.insertBefore(divider2, afterFormForExtras);

        // 2026-09-20: in the Quick View pop-up only, the Description and
        // Measurements tabs sit ABOVE the "England, UK Based..." grid (right
        // before the divider that opens it), per request. On product pages
        // they stay where they were, below it.
        if (quickViewRoot) {
          if (typeof descAccordion !== 'undefined' && descAccordion) {
            // Same dark grey rule as the one above the trust grid, sectioning
            // the tabs off from the payment icons above them (per request).
            var tabsDivider = document.createElement('hr');
            tabsDivider.className = 'product__divider product__divider--tabs';
            divider.parentNode.insertBefore(tabsDivider, divider);
          }
          // 2026-09-22: Measurements above Description here too.
          if (typeof measAccordion !== 'undefined' && measAccordion) divider.parentNode.insertBefore(measAccordion, divider);
          if (typeof descAccordion !== 'undefined' && descAccordion) divider.parentNode.insertBefore(descAccordion, divider);
        }
      }

      liquidData.remove();
    }

    // 2026-09-08 follow-up: "fix the order within ... timer to stop the
    // clock from 6pm gmt and reopen time at 9am gmt" — this "Order within
    // HH:MM:SS for same-day dispatch" box (.product__dispatch-timer) is
    // built once here and inserted on every product page, so this one
    // function already governs it site-wide; only ever hid the box once
    // UTC hour reached 18 (6pm, correct), but had no lower bound — at
    // midnight UTC the hour rolls back to 0, which is < 18, so the box
    // immediately reappeared and started counting down again instead of
    // staying hidden until 9am. Added the missing `hour < 9` half of the
    // window so the box only shows (and only counts down to the same
    // 18:00 target) between 9am and 6pm GMT; outside that window
    // (18:00-08:59) it stays hidden exactly like the existing >=18 branch
    // already did, just for the extra hours.
    var dispatchTimerEls = scope.querySelectorAll('.product__dispatch-timer');
    var dispatchCountdownEls = scope.querySelectorAll('[data-dispatch-countdown]');
    if (dispatchCountdownEls.length) {
      var pad2 = function (n) {
        return String(n).padStart(2, '0');
      };
      var updateDispatchCountdowns = function () {
        var now = new Date();
        var hour = now.getUTCHours();
        if (hour >= 18 || hour < 9) {
          dispatchTimerEls.forEach(function (el) {
            el.style.display = 'none';
          });
          return;
        }
        dispatchTimerEls.forEach(function (el) {
          el.style.display = '';
        });
        var target = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 18, 0, 0));
        var diff = target - now;
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        var text = pad2(hours) + ':' + pad2(minutes) + ':' + pad2(seconds);
        dispatchCountdownEls.forEach(function (el) {
          el.textContent = text;
        });
      };
      updateDispatchCountdowns();
      setInterval(updateDispatchCountdowns, 1000);
    }

    // 2026-09-09 (desktop only): wide landscape photos in the product
    // gallery rendered letterboxed — the slides are square and images
    // use object-fit:contain, so a 2:1 photo (e.g. Lion Mane's
    // cat-in-bed shot, 715x364) showed as a short band with big empty
    // bars, reading as "smaller than the other photos" (user-reported).
    // Wide images (aspect > 1.15) switch to object-fit:cover so they
    // fill the square frame like every other photo — center-cropped at
    // the sides. Square and portrait images are untouched.
    if (window.matchMedia('(min-width: 750px)').matches) {
      scope.querySelectorAll('[id^="GalleryViewer"] .product__media-item img').forEach(function (galleryImg) {
        // 2026-09-20: not inside the Quick View pop-up (this file runs again
        // when its content loads). There every photo card is one fixed
        // square (quick-add.css) with the photo fitted inside uncropped;
        // cover would crop the Pirate / Cowboy Denim photos in that square.
        if (galleryImg.closest('quick-add-modal')) return;
        // 2026-09-10: the Lion Mane first photo (transparent-background
        // cat, black-lion-mane-cat-costume-v2) rendered blurry — this
        // <img> element's decoded bitmap was locked at ~282px and would
        // not upgrade to the 768px source that's actually available,
        // even after clearing srcset and re-pointing src (confirmed: the
        // exact same URL decodes at 768 in a fresh Image() and in a
        // fresh <img> node in the same slot, but never on the original
        // element — the element itself was poisoned). Fix: swap in a
        // clean replacement <img> node carrying a single high-res src
        // (Shopify caps at the 768px original = the real quality
        // ceiling). Filename-matched so nothing else is touched; the
        // fresh node keeps this one's classes so gallery styling holds.
        var galSrc = galleryImg.currentSrc || galleryImg.src || '';
        if (galSrc.indexOf('black-lion-mane-cat-costume-v2') !== -1 && galleryImg.parentNode) {
          var fresh = document.createElement('img');
          fresh.className = galleryImg.className;
          fresh.alt = galleryImg.alt;
          fresh.src = galSrc.split('?')[0] + '?v=1788020434&width=1500';
          // 2026-09-10: rendered smaller than the frame per request —
          // 2cm smaller, then +1cm = net 1cm smaller (0.5cm inset each
          // side); object-fit:contain keeps the whole cutout centred and
          // uncropped.
          fresh.style.setProperty('object-fit', 'contain', 'important');
          fresh.style.padding = '0.5cm';
          fresh.style.boxSizing = 'border-box';
          galleryImg.parentNode.replaceChild(fresh, galleryImg);
          return; // this image needs no cover/portrait handling
        }

        var applyCoverIfWide = function () {
          if (!galleryImg.naturalWidth || !galleryImg.naturalHeight) return;
          // 2026-09-10: ONE exemption, per explicit request — the Witch
          // Cloak page's first photo (dog on transparent background,
          // witch-cloak-listing-original-transparent.png). The generic
          // portrait-cover rule below was cropping its hat tip and
          // paws; this image instead stays uncropped (contain) and
          // renders smaller via padding (width scaling along). Sized 3cm
          // smaller first, then +2cm per follow-up → net 1cm smaller
          // (0.5cm per side). Matched by filename so no other photo
          // anywhere — including other witch-cloak shots — is affected.
          if ((galleryImg.currentSrc || galleryImg.src || '').indexOf('witch-cloak-listing-original-transparent') !== -1) {
            galleryImg.style.setProperty('object-fit', 'contain', 'important');
            // net 0.5cm smaller than the frame (0.25cm per side) after
            // the 3cm → +2cm → +0.5cm follow-up sequence
            galleryImg.style.padding = '0.25cm 0';
            galleryImg.style.boxSizing = 'border-box';
            // sharpness ("less blurry"): force a larger srcset candidate
            // than the layout hint would pick, so scaled-up/high-DPI
            // displays render from a downscaled (never upscaled) source
            if (galleryImg.sizes) galleryImg.sizes = '1100px';
            return;
          }
          var imgAspect = galleryImg.naturalWidth / galleryImg.naturalHeight;
          // 2026-09-09 follow-up: portrait photos included too (e.g.
          // Lion Mane's 9:16 lady-with-shades shot, 715x1281) — those
          // pillarboxed with bars at the SIDES, same "smaller than the
          // other photos" complaint in the other direction. Anything
          // close to square keeps the original contain behavior.
          if (imgAspect <= 1.15 && imgAspect >= 0.87) return;
          // 2026-11-03: size guide charts must show in full, never cropped.
          if ((galleryImg.alt || '').indexOf('size and fit guide') !== -1) return;
          // inline !important: the gallery has a section-scoped
          // `object-fit: contain !important` rule (deliberate, for
          // square photos) that outranks a plain inline style
          galleryImg.style.setProperty('object-fit', 'cover', 'important');
          // Cover-cropping a WIDE image into the square frame shows
          // only its middle slice, effectively magnifying it by its
          // aspect ratio — the srcset candidate chosen for the frame's
          // nominal width is then upscaled and blurry (user-reported).
          // Raising the sizes hint to frameWidth × aspect makes the
          // browser re-pick a proportionally larger candidate. Portrait
          // images don't magnify horizontally (cover fills their width
          // 1:1), so their sizes hint stays as-is.
          if (imgAspect > 1) {
            var frameWidth = galleryImg.getBoundingClientRect().width || 624;
            var neededCssWidth = Math.ceil(frameWidth * imgAspect);
            if (galleryImg.sizes) galleryImg.sizes = neededCssWidth + 'px';
          }
        };
        if (galleryImg.complete) {
          applyCoverIfWide();
        } else {
          galleryImg.addEventListener('load', applyCoverIfWide, { once: true });
        }
      });
    }

    var mediaGalleryEl = scope.querySelector('media-gallery');
    var videoPanelEl = scope.querySelector('.product__video-panel');
    if (mediaGalleryEl && videoPanelEl) {
      var gallerySectionId = mediaGalleryEl.id.replace('MediaGallery-', '');
      var viewerSliderEl = scopeById('GalleryViewer-' + gallerySectionId);
      var gallerySliderListEl = viewerSliderEl ? viewerSliderEl.querySelector('.product__media-list') : null;
      var thumbSliderEl = scopeById('GalleryThumbnails-' + gallerySectionId);
      var thumbListEl = thumbSliderEl ? thumbSliderEl.querySelector('.thumbnail-list') : null;

      if (gallerySliderListEl && thumbListEl) {
        var videoMediaId = gallerySectionId + '-video';

        var videoSlideLi = document.createElement('li');
        videoSlideLi.id = 'Slide-' + videoMediaId;
        videoSlideLi.className = 'product__media-item product__media-item--video grid__item slider__slide';
        videoSlideLi.setAttribute('data-media-id', videoMediaId);
        videoSlideLi.appendChild(videoPanelEl);
        gallerySliderListEl.appendChild(videoSlideLi);
        videoPanelEl.hidden = false;

        var VIDEO_POSTER_URLS = {
          'pet-halloween-wizard-cloak-costume-set': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-witch-cloak.jpg',
          'jizai-little-lion-costume-for-pets': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-chinese-lion-dance.jpg',
          'denim-costume-for-pets': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-cowboy-denim.jpg',
          'dog-clothes-and-boxer-cat-costume-outfit': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-boxer-halloween.jpg',
          'halloween-costume-for-dogs-and-cats-funny-pumpkin-outfit': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-pumpkin.jpg',
          'rosaui-cat-costume-small-breeds-dog-costume-red-black-pet-cape-costume-40cm-back-length-17-40cm-neck-girth-cool-neck-armor-adjustable-strap-velcro-closure': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-vampire-cape.jpg',
          'pet-costume-for-dogs-dragon-transformation-outfit': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-dragon.jpg',
          'teddy-pirate-pet-costume-for-halloween-dress-up': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-pirate.jpg',
          'halloween-costume-for-dogs-fun-pet-outfit-set': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-killer-doll.jpg',
          'funny-lion-mane-hat-for-cats-and-kittens': 'https://cdn.shopify.com/s/files/1/1091/6449/5187/files/product-video-poster-lion-mane.jpg'
        };
        var videoPreviewSrc = '';
        for (var posterHandle in VIDEO_POSTER_URLS) {
          if (productPath.indexOf('/products/' + posterHandle) !== -1) {
            videoPreviewSrc = VIDEO_POSTER_URLS[posterHandle];
            break;
          }
        }
        if (!videoPreviewSrc) {
          var firstThumbImg = thumbListEl.querySelector('.thumbnail img');
          videoPreviewSrc = firstThumbImg ? firstThumbImg.currentSrc || firstThumbImg.src : '';
        }

        var videoThumbLi = document.createElement('li');
        videoThumbLi.className = 'thumbnail-list__item slider__slide';
        videoThumbLi.setAttribute('data-target', videoMediaId);
        videoThumbLi.setAttribute('data-media-position', String(thumbListEl.children.length + 1));
        videoThumbLi.innerHTML =
          '<span class="thumbnail__badge" aria-hidden="true">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M7 5v14l12-7z"></path></svg>' +
          '</span>' +
          '<button class="thumbnail global-media-settings global-media-settings--no-shadow product__video-thumbnail-button" aria-label="Load 360 video" aria-controls="GalleryViewer-' + gallerySectionId + '">' +
          (videoPreviewSrc ? '<img class="product__video-thumbnail-preview" src="' + videoPreviewSrc + '" alt="" loading="lazy">' : '') +
          '</button>';
        thumbListEl.appendChild(videoThumbLi);
        videoThumbLi.querySelector('button').addEventListener('click', function () {
          mediaGalleryEl.setActiveMedia(videoMediaId, false);
        });

        if (viewerSliderEl.resetPages) viewerSliderEl.resetPages();
        if (thumbSliderEl && thumbSliderEl.resetPages) thumbSliderEl.resetPages();

        // 2026-09-09 IMPORTANT GEOMETRY NOTE (do not "fix" again): on
        // desktop this peek-style viewer's FEATURED (large, center)
        // position is the SECOND slot of the scroll viewport — the
        // slide at scrollLeft + one pitch — not the first. Scrolling
        // to the video's own offsetLeft is impossible (max scroll is
        // one viewport short), and that's CORRECT: the inline arrow
        // script's scrollTo(video.offsetLeft) clamps to max scroll,
        // which lands the VIDEO in the featured slot while the class
        // bookkeeping also says index 4 — everything lines up by
        // design. A trailing margin was added here once to make
        // scrollLeft reach video.offsetLeft "properly" and it broke
        // the layout (blank featured slot, video shoved to the left
        // peek) — confirmed with real clicks and reverted same day.

        var videoEl = videoPanelEl.querySelector('video');
        if (videoEl && viewerSliderEl) {
          // 2026-09-09 (desktop only): fetch the whole video up front.
          // It ships with preload="metadata", so the first arrival on
          // the video slide called play() against an empty buffer — the
          // frame sat still for the whole fetch, reading as "it didn't
          // play", and the natural reaction (clicking the video) hits
          // the panel's play/pause toggle and actually PAUSES it — the
          // user-reported "I have to click twice". Preloading makes
          // arrival playback instant. Desktop-gated so mobile's data
          // usage is unchanged.
          if (window.matchMedia('(min-width: 750px)').matches) {
            videoEl.preload = 'auto';
            try {
              videoEl.load();
            } catch (preloadError) {
              /* ignore */
            }
          }
          viewerSliderEl.addEventListener('slideChanged', function (event) {
            if (event.detail.currentElement.dataset.mediaId === videoMediaId) {
              videoEl.play();
            }
          });

          // 2026-09-09 (desktop only): the slideChanged wiring above only
          // fires from real slider SCROLLING — mobile swipes. On desktop
          // this gallery switches slides by class-toggling instead
          // (thumbnail clicks go through media-gallery's setActiveMedia,
          // the white square arrows + dots go through the inline
          // scrollToSlide/updateState script in
          // snippets/product-media-gallery.liquid), so nothing scrolls
          // and the video slide arrived paused (user-reported). One
          // delegated click listener covers every desktop navigation
          // control: after the navigation handlers have run (50ms), if
          // the now-active slide is the 360 video, play it — restoring
          // the panel's own play/pause overlay to its "playing" state in
          // case the visitor had paused it earlier — and if it isn't,
          // pause it so it doesn't keep playing hidden in the
          // background.
          // 2026-09-09 v2 (desktop only) — GEOMETRY-driven, replacing an
          // earlier is-active-class approach: the inline nav script's
          // class bookkeeping runs one slide BEHIND what's visually
          // featured (at rest the featured slot shows slide N+1 while
          // the classes say N — see the geometry note above), so the
          // class-based version only played the video one arrow-click
          // AFTER it had already appeared on screen (user-reported:
          // "works only if I click the arrow twice once the video first
          // comes on screen"). Now the truth comes from the scroller
          // itself: whichever slide physically occupies the featured
          // slot (scrollLeft + one slide pitch, nearest match) when
          // scrolling settles. Every navigation path — arrows, dots,
          // thumbnails, the 360 thumb — moves this scroller, so one
          // debounced scroll listener covers them all, and the video
          // starts within ~0.2s of landing on screen.
          var isVideoFeaturedNow = function () {
            var allSlides = gallerySliderListEl.querySelectorAll('.product__media-item');
            if (allSlides.length < 2) return false;
            var pitch = allSlides[1].offsetLeft - allSlides[0].offsetLeft;
            if (pitch <= 0) return false;
            var featuredLeft = gallerySliderListEl.scrollLeft + pitch;
            var best = null;
            var bestDist = Infinity;
            for (var si = 0; si < allSlides.length; si++) {
              var dist = Math.abs(allSlides[si].offsetLeft - featuredLeft);
              if (dist < bestDist) {
                bestDist = dist;
                best = allSlides[si];
              }
            }
            return best === videoSlideLi;
          };
          // 2026-09-09: iOS-message-style notification, desktop only —
          // shown ONCE, the first time the visitor actually lands on
          // the 360 video (the same geometry check that starts
          // playback). "Looking for more videos?" with a down arrow;
          // clicking scrolls to the As Seen On You reel section; it
          // dismisses itself after 5s. Replaces the older bottom-right
          // teaser on desktop (that one is now mobile-only, see the
          // slideChanged handler below) and only appears when the
          // As Seen On You section actually exists on this product.
          var desktopVideoNoteShown = false;
          var maybeShowDesktopVideoNote = function () {
            if (desktopVideoNoteShown) return;
            var reelSection = scope.querySelector('.product__as-seen-on-you');
            if (!reelSection) return;
            desktopVideoNoteShown = true;
            setTimeout(function () {
              var note = document.createElement('button');
              note.type = 'button';
              note.className = 'product__video-ios-note';
              // 2026-09-10: icon tile removed per request — text + one
              // down arrow only.
              note.innerHTML =
                '<span class="product__video-ios-note-text">Looking for more videos?</span>' +
                '<span class="product__video-ios-note-arrow" aria-hidden="true">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v14M6 12l6 7 6-7"/></svg>' +
                '</span>';
              // 2026-09-09 follow-up: anchored to the BOTTOM of the 360
              // video itself (appended inside the video panel, absolute
              // bottom-center, rising up from below) instead of dropping
              // from the top of the screen, per request.
              videoPanelEl.appendChild(note);
              requestAnimationFrame(function () {
                note.classList.add('is-visible');
              });

              var noteTimer = setTimeout(dismissNote, 5000);

              function dismissNote() {
                note.classList.remove('is-visible');
                note.classList.add('is-leaving');
                // removal waits out the 0.45s keyframed exit
                setTimeout(function () {
                  note.remove();
                }, 500);
              }

              note.addEventListener('click', function (noteClickEvent) {
                // the panel's own click handler is the video's
                // play/pause toggle — don't let this click reach it
                noteClickEvent.stopPropagation();
                clearTimeout(noteTimer);
                dismissNote();
                var headerHeightRaw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
                var headerHeight = parseFloat(headerHeightRaw) || 80;
                var reelTarget = scope.querySelector('.product__as-seen-on-you');
                if (!reelTarget) return;
                var targetTop = reelTarget.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
                window.scrollTo({ top: targetTop, behavior: 'smooth' });
              });
            }, 1200);
          };

          var applyFeaturedVideoState = function () {
            if (!window.matchMedia('(min-width: 750px)').matches) return;
            if (isVideoFeaturedNow()) {
              videoEl.play();
              maybeShowDesktopVideoNote();
              // If the buffer is still empty (slow connection, preload
              // not finished), play() alone shows a frozen frame until
              // data arrives — re-kick playback the moment it's
              // playable, if the video is still the featured slide.
              if (videoEl.readyState < 2) {
                videoEl.addEventListener(
                  'canplay',
                  function () {
                    if (isVideoFeaturedNow()) videoEl.play();
                  },
                  { once: true }
                );
              }
              videoPanelEl.classList.remove('product__video-panel--paused');
              var panelPauseIcon = videoPanelEl.querySelector('[data-pause-icon]');
              var panelPlayIcon = videoPanelEl.querySelector('[data-play-icon]');
              if (panelPauseIcon) panelPauseIcon.style.display = '';
              if (panelPlayIcon) panelPlayIcon.style.display = 'none';
            } else {
              videoEl.pause();
            }
          };
          var featuredCheckTimer = null;
          gallerySliderListEl.addEventListener(
            'scroll',
            function () {
              clearTimeout(featuredCheckTimer);
              featuredCheckTimer = setTimeout(applyFeaturedVideoState, 120);
            },
            { passive: true }
          );
        }

        // 2026-09-05: nudge visitors who swipe to this 360 video slide
        // toward the real customer-clip videos further down the page —
        // only wired up when this product actually has real reel clips
        // there. `descAccordion` and `reelVideos` are both `var`s set
        // earlier in this same outer function (hoisted, so visible here) —
        // `descAccordion` always exists whenever `descBlock` does (it's
        // built unconditionally, before the measurementsHtml check), and
        // this whole block only runs once `reelVideos.length` is confirmed
        // too, only when the description's 📏 marker AND a
        // REEL_VIDEOS_BY_PATH entry both exist for this product; guarding
        // on both means this never promises "more videos" on a product
        // that doesn't actually have any.
        if (
          viewerSliderEl &&
          typeof descAccordion !== 'undefined' &&
          descAccordion &&
          typeof reelVideos !== 'undefined' &&
          reelVideos &&
          reelVideos.length
        ) {
          var moreVideosTeaserShown = false;
          viewerSliderEl.addEventListener('slideChanged', function (event) {
            // 2026-09-09: mobile-only now — desktop uses the
            // iOS-message-style notification built above instead
            // (triggered by the geometry-based featured check).
            if (window.matchMedia('(min-width: 750px)').matches) return;
            if (event.detail.currentElement.dataset.mediaId === videoMediaId && !moreVideosTeaserShown) {
              moreVideosTeaserShown = true;
              // 2026-09-05 follow-up: delayed 1.5s after the video slide
              // becomes active (rather than showing instantly), so the
              // teaser doesn't compete for attention the moment the video
              // itself starts playing.
              setTimeout(function () {
                // 2026-09-05 follow-up #2: scrolls to the Description
                // accordion per explicit follow-up request — clicking the
                // teaser lands with Description at the top of the viewport.
                // (Since 2026-09-22 Measurements sits above it; the As Seen
                // On You row is directly below Description, still in view.)
                showMoreVideosTeaser(descAccordion);
              }, 1500);
            }
          });
        }
      }
    }

    // 2026-09-05 follow-up: moved from straddling the gallery/info-column
    // seam to sitting directly on top of the large photo/video itself,
    // bottom-right corner — appended INSIDE `viewerSliderEl` (the
    // `#GalleryViewer-...` slider-component that wraps only the main
    // slide `<ul>`, not the separate thumbnail row) rather than
    // `.product__media-wrapper`, so it overlays the media itself instead
    // of the seam below it, and so its rightward swoop-out has a
    // consistent box to escape past. Falls back to `.product__media-wrapper`
    // if `viewerSliderEl` isn't in scope for some reason. Entrance is a
    // real iOS-notification bounce-in (overshoot easing); exit is a
    // distinct rightward swoop (`is-leaving`), not just the entrance
    // reversed — dismiss() now adds `is-leaving` instead of only removing
    // `is-visible` so the CSS can apply a different transform/timing.
    function showMoreVideosTeaser(targetSection) {
      var anchorEl = (typeof viewerSliderEl !== 'undefined' && viewerSliderEl) || scope.querySelector('.product__media-wrapper');
      if (!anchorEl) return;

      var teaser = document.createElement('button');
      teaser.type = 'button';
      teaser.className = 'product__more-videos-teaser';
      teaser.innerHTML =
        '<span class="product__more-videos-teaser-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12l7 7 7-7"/></svg>' +
        '</span>' +
        '<span class="product__more-videos-teaser-text">Looking for more videos on this product?</span>';
      anchorEl.appendChild(teaser);
      requestAnimationFrame(function () {
        teaser.classList.add('is-visible');
      });

      var dismissTimer = setTimeout(dismiss, 6000);

      function dismiss() {
        teaser.classList.remove('is-visible');
        teaser.classList.add('is-leaving');
        setTimeout(function () {
          teaser.remove();
        }, 400);
      }

      teaser.addEventListener('click', function () {
        clearTimeout(dismissTimer);
        dismiss();
        // Reads the theme's own --header-height custom property (kept up
        // to date by Dawn's sticky-header JS) rather than a guessed fixed
        // offset, so the section lands just below the header regardless of
        // header height changing between breakpoints or theme settings.
        var headerHeightRaw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        var headerHeight = parseFloat(headerHeightRaw) || 80;
        var targetTop = targetSection.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
        window.scrollTo({ top: targetTop, behavior: 'smooth' });
      });
    }

    // 2026-09-22: the review pop-up used to show only the single review
    // stored in the product's metafields, even when the count said "8
    // reviews". It now fetches the homepage "Customer Reviews" section (the
    // one place all reviews are entered, via the theme editor) through
    // Shopify's section rendering endpoint and shows every review for this
    // product, in a scrollable list. Later the same day: the stars, score
    // and "(N reviews)" label above the title are ALSO recomputed from that
    // data on page load, so the metafields (reviews.rating / rating_count /
    // the single review) are now only the server-rendered first paint and
    // the fallback if the fetch fails.
    var ratingSummary = scope.querySelector('.product__rating-summary');
    var reviewTrigger = scope.querySelector('[data-product-review-trigger]');
    if (ratingSummary) {
      var fallbackReview = reviewTrigger ? {
        rating: reviewTrigger.getAttribute('data-review-rating'),
        name: reviewTrigger.getAttribute('data-reviewer-name'),
        location: reviewTrigger.getAttribute('data-review-location'),
        date: reviewTrigger.getAttribute('data-review-date'),
        text: reviewTrigger.getAttribute('data-review-text')
      } : null;
      var productHandle = ratingSummary.getAttribute('data-product-handle') || '';
      var allReviewsPromise = null;

      // The section rendering endpoint wants the FULL section id (the short
      // "reviews_popup" key returns an empty string). That id embeds the
      // homepage template's number, which changes if the theme is ever
      // re-published, so if it comes back empty we fall back to fetching
      // the homepage itself (bigger, ~700 KB vs ~120 KB) and reading the
      // same cards out of it.
      var REVIEWS_SECTION_ID = 'template--31237708087635__reviews_popup';
      var parseReviewCards = function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.review-card[data-review-product="' + productHandle + '"]');
        var text = function (card, sel) {
          var el = card.querySelector(sel);
          return el ? el.textContent.trim() : '';
        };
        return Array.prototype.map.call(cards, function (card) {
          return {
            rating: card.getAttribute('data-review-rating'),
            name: text(card, '.review-card__name'),
            location: text(card, '.review-card__location'),
            date: text(card, '.review-card__date'),
            text: text(card, '.review-card__text')
          };
        });
      };
      var fetchAllReviews = function () {
        if (allReviewsPromise) return allReviewsPromise;
        allReviewsPromise = fetch('/?sections=' + REVIEWS_SECTION_ID, { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error(res.status)); })
          .then(function (data) {
            var html = data && data[REVIEWS_SECTION_ID];
            if (html) return parseReviewCards(html);
            return fetch('/', { credentials: 'same-origin' })
              .then(function (res) { return res.ok ? res.text() : Promise.reject(new Error(res.status)); })
              .then(parseReviewCards);
          })
          .catch(function () { return []; });
        return allReviewsPromise;
      };

      var onTriggerClick = function () {
        fetchAllReviews().then(function (reviews) {
          if (reviews.length) openProductReviewModal(reviews);
          else if (fallbackReview) openProductReviewModal([fallbackReview]);
        });
      };
      if (reviewTrigger) reviewTrigger.addEventListener('click', onTriggerClick);

      // Recompute the summary row from the live homepage reviews: star
      // fills, the numeric score (1 dp) and the "(N reviews)" label. If the
      // label is a plain span (product has no review metafields yet) it is
      // swapped for a button so the pop-up works there too.
      var applyLiveSummary = function (reviews) {
        if (!reviews.length) return;
        var sum = 0;
        reviews.forEach(function (r) { sum += parseFloat(r.rating) || 0; });
        var average = Math.round((sum / reviews.length) * 10) / 10;
        var full = Math.floor(average);
        var frac = average - full;
        Array.prototype.forEach.call(ratingSummary.querySelectorAll('.product__rating-star-fill'), function (fill, i) {
          var star = i + 1;
          fill.style.width = (star <= full ? 100 : star === full + 1 ? Math.round(frac * 100) : 0) + '%';
        });
        var label = '/5 (' + reviews.length + ' review' + (reviews.length === 1 ? '' : 's') + ')';
        var valueEl = ratingSummary.querySelector('.product__rating-value');
        var countEl = ratingSummary.querySelector('.product__rating-count');
        if (!valueEl) {
          valueEl = document.createElement('span');
          valueEl.className = 'product__rating-value';
          ratingSummary.insertBefore(valueEl, countEl);
        }
        valueEl.textContent = average.toFixed(1);
        if (countEl && countEl.tagName !== 'BUTTON') {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'product__rating-count';
          button.setAttribute('data-product-review-trigger', '');
          countEl.parentNode.replaceChild(button, countEl);
          countEl = button;
          reviewTrigger = button;
          button.addEventListener('click', onTriggerClick);
        }
        if (countEl) countEl.textContent = label;
      };
      fetchAllReviews().then(applyLiveSummary);
    }

    function openProductReviewModal(reviews) {
      var overlay = document.createElement('div');
      overlay.className = 'product__review-modal-overlay';

      var sheet = document.createElement('div');
      sheet.className = 'product__review-modal';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.setAttribute('aria-label', 'Customer review');

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'product__review-modal-close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      sheet.appendChild(closeBtn);

      var grabber = document.createElement('span');
      grabber.className = 'product__review-modal-grabber';
      grabber.setAttribute('aria-hidden', 'true');
      sheet.appendChild(grabber);

      var heading = document.createElement('h2');
      heading.className = 'product__review-modal-heading';
      heading.textContent = reviews.length === 1 ? 'Customer Review' : 'Customer Reviews';
      sheet.appendChild(heading);

      if (reviews.length > 1) {
        var summary = document.createElement('p');
        summary.className = 'product__review-modal-summary';
        summary.textContent = 'Based on ' + reviews.length + ' reviews';
        sheet.appendChild(summary);
      }

      // Scrollable list: the sheet itself is capped at 80vh (CSS), so with
      // several cards the list scrolls inside it and the close button and
      // heading stay put.
      var list = document.createElement('div');
      list.className = 'product__review-list';
      reviews.forEach(function (review) {
        list.appendChild(buildReviewCard(review));
      });
      sheet.appendChild(list);
      overlay.appendChild(sheet);
      document.body.appendChild(overlay);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('is-open');
        });
      });

      var previouslyFocused = document.activeElement;

      function closeModal() {
        overlay.classList.remove('is-open');
        document.removeEventListener('keydown', onKeydown);
        overlay.addEventListener('transitionend', onTransitionEnd);
        window.setTimeout(removeOverlay, 300);
      }

      var removed = false;
      function removeOverlay() {
        if (removed) return;
        removed = true;
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
      }

      function onTransitionEnd(event) {
        if (event.target === sheet) removeOverlay();
      }

      function onKeydown(event) {
        if (event.key === 'Escape') closeModal();
      }

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closeModal();
      });
      closeBtn.addEventListener('click', closeModal);
      document.addEventListener('keydown', onKeydown);
      closeBtn.focus();

      var dragStartY = null;
      var dragCurrentY = 0;
      var dragging = false;

      function onDragStart(event) {
        dragging = true;
        dragStartY = event.clientY;
        dragCurrentY = 0;
        sheet.style.transition = 'none';
        grabber.setPointerCapture(event.pointerId);
      }

      function onDragMove(event) {
        if (!dragging) return;
        var dy = event.clientY - dragStartY;
        if (dy < 0) dy = 0;
        dragCurrentY = dy;
        sheet.style.transform = 'translateY(' + dy + 'px)';
      }

      function onDragEnd() {
        if (!dragging) return;
        dragging = false;
        sheet.style.transition = '';
        sheet.style.transform = '';
        if (dragCurrentY > 80) closeModal();
        dragCurrentY = 0;
      }

      grabber.addEventListener('pointerdown', onDragStart);
      grabber.addEventListener('pointermove', onDragMove);
      grabber.addEventListener('pointerup', onDragEnd);
      grabber.addEventListener('pointercancel', onDragEnd);
    }

    function buildReviewCard(review) {
      var card = document.createElement('div');
      card.className = 'product__review-card';

      var meta = document.createElement('div');
      meta.className = 'product__review-card-meta';
      var nameEl = document.createElement('span');
      nameEl.className = 'product__review-card-name';
      nameEl.textContent = review.name || '';
      var locationEl = document.createElement('span');
      locationEl.className = 'product__review-card-location';
      locationEl.textContent = review.location || '';
      meta.appendChild(nameEl);
      meta.appendChild(locationEl);
      card.appendChild(meta);

      var row = document.createElement('div');
      row.className = 'product__review-card-row';
      var starsEl = document.createElement('div');
      starsEl.className = 'product__review-card-stars';
      starsEl.setAttribute('aria-hidden', 'true');
      var ratingNum = parseFloat(review.rating) || 0;
      var ratingFull = Math.floor(ratingNum);
      var ratingFrac = ratingNum - ratingFull;
      for (var i = 1; i <= 5; i++) {
        var fillPercent = 0;
        if (i <= ratingFull) {
          fillPercent = 100;
        } else if (i === ratingFull + 1) {
          fillPercent = Math.round(ratingFrac * 100);
        }
        var starWrap = document.createElement('span');
        starWrap.className = 'star-char-wrap';
        var starBg = document.createElement('span');
        starBg.className = 'star-char is-empty';
        starBg.textContent = '★';
        var starFillEl = document.createElement('span');
        starFillEl.className = 'star-char-fill';
        starFillEl.style.width = fillPercent + '%';
        var starFg = document.createElement('span');
        starFg.className = 'star-char';
        starFg.textContent = '★';
        starFillEl.appendChild(starFg);
        starWrap.appendChild(starBg);
        starWrap.appendChild(starFillEl);
        starsEl.appendChild(starWrap);
      }
      var dateEl = document.createElement('span');
      dateEl.className = 'product__review-card-date';
      dateEl.textContent = review.date || '';
      row.appendChild(starsEl);
      row.appendChild(dateEl);
      card.appendChild(row);

      var textEl = document.createElement('p');
      textEl.className = 'product__review-card-text';
      textEl.textContent = review.text || '';
      card.appendChild(textEl);

      return card;
    }
  });
})();
